
<div>
  <strong>Product</strong> / Billing / Review / Payment / Confirmation
</div>
<hr class="hrDiv">
<div class="pageContainer">
  <div class="topSectnDiv">
    <div *ngIf="isPhonePortrait" class="imgDivPhone">
      <img src="{{imgPath}}">
    </div>
    <div *ngIf="isPhonePortrait && !isUserWithSub" class="itemDivPhone">
      <div class="qntyDivPhone">
        <mat-form-field>
          <mat-label>Select Quantity</mat-label>
          <mat-select [(ngModel)]="selectedQty" name="prodQty">
            <mat-option *ngFor="let qty of qtyList" [value]="qty">
              {{qty}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="submit-button floatRight paddingR20">
        <button mat-fab extended class="btn-cls" (click)="addToCart()">Add To Cart</button>
      </div> 
    </div>
    <div [ngClass]="[isPhonePortrait? 'aboutDivPhone':'aboutDiv']">
      <h1>About</h1><br>
      <p [innerHTML]='prodDetails.about'></p>
    </div>
    <div *ngIf="!isPhonePortrait" class="imgDiv"> 
      <img src="{{imgPath}}">
    </div>
    <div *ngIf="!isPhonePortrait" [ngClass]="[isTablet? 'itemDivTab':'itemDiv']">
      <div [ngClass]="[isTablet? 'qntyDivTab':'qntyDiv']" *ngIf="!isUserWithSub"> 
        <mat-form-field>
          <mat-label>Select Number of Users</mat-label>
          <mat-select [(ngModel)]="selectedQty" name="prodQty">
            <mat-option *ngFor="let qty of qtyList" [value]="qty">
              {{qty}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="submit-button floatRight paddingR20" *ngIf="!isUserWithSub">
        <button mat-fab extended class="btn-cls" (click)="addToCart()">Add To Cart</button>
      </div> 
      <div *ngIf="isUserWithSub">
        <p>
          Your subscription expires on {{subscriptions[0].expireDate}}. <br> 
          Please contact your administrator <u><a href="mailto:{{subscriptions[0].adminEmail}}">{{subscriptions[0].adminName}}</a></u>  if you have questions.
        </p>
      </div>
    </div>
  </div>

  <div class="panelContainer">
    <div class="panelDiv">
      <mat-expansion-panel class="panelCls">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h2>Features</h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p [innerHTML]='prodDetails.features'></p>
      </mat-expansion-panel>
    </div>
    <div class="panelDiv">
      <mat-expansion-panel class="panelCls">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h2>Uses</h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p [innerHTML]='prodDetails.uses'></p>
      </mat-expansion-panel>
    </div>
  </div>
  <div class="botSectnDiv">
    <p [innerHTML]='prodDetails.addl'></p>
  </div>
</div>